import {
    containsLowercaseLetter,
    containsNumber,
    containsUppercaseLetter,
    hasSpecialCharacter,
    isBetweenEightAndNinetyNineCharacters,
    isValidEmailAddress,
    isNotUsersEmailAddress,
    isPositiveInteger,
    isValidDateMinutesOrSeconds,
    isValidDateHours,
    isValidDateYear,
    isValidDateMonth,
    isValidDateDay,
    containsNoSpaces,
} from './rules';

export const ruleSets: Record<string, Rule[]> = {
    email: [isValidEmailAddress],
    emailOtherThanUser: [isValidEmailAddress, isNotUsersEmailAddress],
    password: [
        isBetweenEightAndNinetyNineCharacters,
        containsLowercaseLetter,
        containsUppercaseLetter,
        containsNumber,
        hasSpecialCharacter,
    ],
    listObjectsInS3UserId: [containsNoSpaces],
    listObjectsInS3MaxResults: [isPositiveInteger],
    dateYear: [isValidDateYear],
    dateMonth: [isValidDateMonth],
    dateDay: [isValidDateDay],
    dateHours: [isValidDateHours],
    dateMinutes: [isValidDateMinutesOrSeconds],
    dateSeconds: [isValidDateMinutesOrSeconds],
};
